/* Zivaria product page (desktop): photos scroll while the info column stays put;
   when the last photo reaches the bottom of the screen it is held there while the
   info column scrolls to its end, then the page moves on. Driven by the page's
   scroll position, so it works with trackpad, mouse wheel, keyboard and scrollbar. */
(() => {
  if (window.__zvPdpChain) return;
  window.__zvPdpChain = true;

  const wide = window.matchMedia('(min-width: 990px)');
  let col = null;
  let media = null;
  let panel = null;
  let photosH = 0;
  let range = 0;
  let spacer = null;

  const setSpacer = (px) => {
    if (!spacer) {
      spacer = document.createElement('div');
      spacer.setAttribute('aria-hidden', 'true');
    }
    if (spacer.parentNode !== col) col.appendChild(spacer);
    spacer.style.height = px + 'px';
  };

  const reset = () => {
    if (spacer) spacer.remove();
    if (media) {
      media.style.position = '';
      media.style.top = '';
    }
    if (panel) {
      panel.style.overflowY = '';
      panel.scrollTop = 0;
    }
  };

  const sync = () => {
    if (!col || !panel || !wide.matches) return;
    const top = col.getBoundingClientRect().top;
    // How far the page went past "last photo ends at the bottom of the screen"
    panel.scrollTop = Math.max(0, Math.min(range, innerHeight - (top + photosH)));
  };

  const measure = () => {
    col = document.querySelector('.zv-pdp__gallery');
    media = col && col.querySelector('.zv-pdp__media');
    panel = document.querySelector('.zv-pdp__sticky');
    if (!col || !media || !panel) return;
    if (!wide.matches) {
      reset();
      return;
    }
    panel.style.overflowY = 'hidden';
    setSpacer(0);
    photosH = media.offsetHeight;
    range = Math.max(0, panel.scrollHeight - panel.clientHeight);
    // Extra room under the photos = the distance the info column still has to travel
    setSpacer(range);
    media.style.position = 'sticky';
    media.style.top = Math.min(0, innerHeight - photosH) + 'px';
    sync();
  };

  const start = () => {
    measure();
    if (!media || !panel) return;
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(measure);
      ro.observe(media);
      [...panel.children].forEach((el) => ro.observe(el));
    }
  };

  document.addEventListener('scroll', sync, { capture: true, passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  document.addEventListener('toggle', measure, true);
  wide.addEventListener('change', measure);
  document.addEventListener('shopify:section:load', start);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
